import LoadingPlaceholderBlock from "../../../../common/LoadingPlaceholderBlock";
import React from "react";
import {Box, Grid, Stack} from "@mui/material";

const AttributionEmptyState = () => {
    return (
        <Grid container columns={4} spacing={3} sx={styles.gridStyle}>
            {[...new Array(4)].map((item, index) => {
                    return (
                        <Grid item xs={4} md={1} key={index}>
                            <Stack>
                                <Box component={'h4'} sx={styles.label}>
                                    <LoadingPlaceholderBlock
                                        height={'16px'}
                                        width={'160px'}
                                        borderRadius={'5px'}
                                        backgroundColor={'rgb(239, 234, 229)'}
                                    />
                                </Box>

                                <Box sx={{marginTop: '15px', marginBottom: '30px'}}>
                                    <LoadingPlaceholderBlock
                                        height={'38px'}
                                        width={'200px'}
                                        borderRadius={'5px'}
                                        backgroundColor={'rgb(239, 234, 229)'}
                                    />
                                </Box>
                                <LoadingPlaceholderBlock
                                    height={'16px'}
                                    width={'230px'}
                                    borderRadius={'5px'}
                                    backgroundColor={'rgb(239, 234, 229)'}
                                />
                            </Stack>
                        </Grid>
                    )
                })}
        </Grid>
    )
}

export default AttributionEmptyState

const styles = {
    gridStyle: {
        position: "relative",
        px: { xs: 2, md: 4 },
        py: { xs: 2, md: 4 },
    },
    label: {
        m: 0,
        fontSize: '15px',
        fontFamily: 'FustatSemiBold',
        letterSpacing: '0.02em',
        textTransform: 'capitalize',
        mb: '10px'
    },
    value: {
        mt: { xs: 1, md: 1.5 },
        mb: { xs: 0, md: 2.5 },
        fontSize: { xs: '40px', md: '48px' },
        fontFamily: 'FustatSemiBold'
    },
    description: {
        fontFamily: 'FustatMedium',
        fontSize: '14px'
    }
}